import { buildAuthHeaders, buildUrl } from "../../../utils/requestToolsV3";
import { searchV3 } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/configuration`;
const headers = buildAuthHeaders();

export async function findConfigurationV3() {
  const url = buildUrl({ path });
  return searchV3(url, "GET", headers);
}
